module.exports = __webpack_public_path__ + "static/c10-0c2063c7ff086ee0be24f06c2741d0c5.png";